module.exports = __webpack_public_path__ + "img/bertille-et-aurelien.52c2440.jpg";